import React, { useEffect, useState } from "react";
import OurLayouts from "../layout/index";
import { format } from "date-fns";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import searchicon from "../../assets/search_icon.svg";
import patientvectoricon from "../../assets/patientvectoricon.svg";
import dateicon from "../../assets/dateicon.svg";
import "../../assets/css/index.css";
import RescheduleSidebar from "./RescheduleSidebar";
import CancelSidebar from "./CancelSidebar";
import ShareLinkModal from "./ShareLinkModal";
import { APP_ROUTES } from "../../constants/approutes";
import {
  FilePdfOutlined,
  FilterOutlined,
  SearchOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import {
  Table,
  Tag,
  Select,
  DatePicker,
  Button,
  Input,
  Drawer,
  Card,
  Row,
  Col,
  Space,
  Divider,
} from "antd";
import axios from "axios";
import VerifyAbhaModal from "../ABHA/VerifyAbhaModal";
import CreateAbhaModal from "../ABHA/CreateAbhaModal";
import bookappointmenticon from "../../assets/bookappointmenticon.svg";
import Videoicon from "../../assets/videoicon.svg";
import Inpersionicon from "../../assets/inpersionicon.svg";
import Upcomingicon from "../../assets/upcomingicon.svg";
import Followupicon from "../../assets/followupicon.svg";
import Completeicon from "../../assets/completeicon.svg";
const statusColors = {
  Completed: "text-[#005277]",
  Active: "text-[#008d7b]",
  QUEUED: "text-orange-400",
  Cancelled: "text-red-700",
  SKIPPED: "text-orange-400",
};

export default function QueueManagement() {
  const disabledFeatures = JSON.parse(
    localStorage.getItem("disabledFeatures") || "[]",
  );
  const [queueData, setQueueData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [nowServingData, setNowServingData] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const navigate = useNavigate();

  const API_URL = process.env.REACT_APP_API_URL;
  const [selectedToken, setSelectedToken] = useState(null);
  const [openDropdownId, setOpenDropdownId] = useState(null);

  const [isRescheduleOpen, setIsRescheduleOpen] = useState(false);
  const [selectedappointmentid, setSelectedappointmentid] = useState("");
  const [selectedSlot, setSelectedSlot] = useState("");
  const [isCancelOpen, setIsCancelOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [selectedCancelId, setSelectedCancelId] = useState(null);
  const [selecteddoctorId, setSelecteddoctorId] = useState(null);
  const [tableSearch, setTableSearch] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [recipient, setRecipient] = useState("");
  const [loading, setLoading] = useState(false);
  const [patientdata, setPatientdata] = useState("");
  const [viewMode, setViewMode] = useState("desktop"); // 'mobile', 'tablet', 'desktop'
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);
  const [invoiceURL, setInvoiceURL] = useState("");
  const [downloadingInvoiceId, setDownloadingInvoiceId] = useState(false);
  const [selecteddoctorid, setSelecteddoctorid] = useState("");
  const [skippingAppointmentId, setSkippingAppointmentId] = useState(null);
  const [isAbhaVerifyOpen, setIsAbhaVerifyOpen] = useState(false);
  const [isAbhaCreateOpen, setIsAbhaCreateOpen] = useState(false);
  const [selectedPatientForAbha, setSelectedPatientForAbha] = useState(null);

  const [activeTab, setActiveTab] = useState("Upcoming");
  const [todayQueueCount, setTodayQueueCount] = useState(2);
  const [saNotFilledCount, setSaNotFilledCount] = useState(2);
  const [followUpCount, setFollowUpCount] = useState(0);
  const [followUpAppointments, setFollowUpAppointments] = useState([]);
  const [loadingFollowUp, setLoadingFollowUp] = useState(false);
  const [completedCount, setCompletedCount] = useState(1);
  const [completedAppointments, setCompletedAppointments] = useState([]);
  const [loadingCompleted, setLoadingCompleted] = useState(false);
  const [upcomingCount, setUpcomingCount] = useState(0);
  const [othersCount, setOthersCount] = useState(0);

  // Check screen size for different views
  useEffect(() => {
    const checkScreenSize = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setViewMode("mobile");
      } else if (width < 1024) {
        setViewMode("tablet");
      } else {
        setViewMode("desktop");
      }
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // Handle clicks outside dropdown to close it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (openDropdownId && !event.target.closest(".dropdown-container")) {
        setOpenDropdownId(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openDropdownId]);

  // Effect to fetch completed appointments when date changes and Completed tab is active
  // useEffect(() => {
  //   // if (activeTab === "Completed") {
  //     fetchCompletedAppointments();
  //   // }
  // }, [selectedDate, activeTab]);

  // Function to fetch follow-up appointments
  const fetchFollowUpAppointments = async () => {
    setLoadingFollowUp(true);
    try {
      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");
      const clinicId = localStorage.getItem("clinicId") || "clinic1";

      // Format selectedDate to YYYY-MM-DD and create a date range (7 days from selected date)
      const fromDate = format(selectedDate, "yyyy-MM-dd");
      const toDate = format(
        new Date(selectedDate.getTime() + 7 * 24 * 60 * 60 * 1000),
        "yyyy-MM-dd",
      );

      const url = `${API_URL}prescriptions/followup-compact?fromDate=${fromDate}&toDate=${fromDate}&clinicId=${clinicId}`;

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          tenantId: tenantId,
        },
      });

      console.log(response.data.data, "followUpAppointments");
      setFollowUpAppointments(response.data.data || []);
      setFollowUpCount(response.data.data?.length || 0);
    } catch (error) {
      console.error("Error fetching follow-up appointments:", error);
      toast.error("Failed to fetch follow-up appointments");
    } finally {
      setLoadingFollowUp(false);
    }
  };

  // Function to fetch completed appointments
  const fetchCompletedAppointments = async () => {
    setLoadingCompleted(true);
    try {
      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");
      const clinicId = localStorage.getItem("clinicId") || "clinic1"; // You can adjust this based on your app logic

      // Format selectedDate to YYYY-MM-DD
      const fromDate = format(selectedDate, "yyyy-MM-dd");
      const toDate = format(selectedDate, "yyyy-MM-dd");

      const url = `${API_URL}queue/appointmentlist?clinicId=${clinicId}&status=COMPLETED&fromDate=${fromDate}&toDate=${toDate}&pageNumber=1&pageSize=10`;

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          tenantId: tenantId,
        },
      });
      console.log(response.data, "rftyguhijko");
      setCompletedAppointments(response.data || []);
      setCompletedCount(response.data?.length || 0);
    } catch (error) {
      console.error("Error fetching completed appointments:", error);
      toast.error("Failed to fetch completed appointments");
    } finally {
      setLoadingCompleted(false);
    }
  };

  const handleSend = async () => {
    const val = recipient.trim();
    console.log(val, "val");
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    // if (!val) {
    //   toast.error("Please enter mobile number.");
    //   return;
    // }
    if (!val) {
      toast.error("Please enter mobile number or email.");
      return;
    }

    const isMobile = /^[0-9]{10}$/.test(val);
    const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
    if (!isMobile && !isEmail) {
      toast.error(
        "Please enter a valid 10-digit mobile number or a valid email address.",
      );
      return;
    }

    const url = process.env.REACT_APP_SHARE_CALL;
    // const shareurl = `https://doctor-stage.curebay.in/sharecall/${patientdata.appointmentId}/V`;
    const shareurl =
      url +
      APP_ROUTES.SHARECALL.split("/")[1] +
      "/" +
      patientdata.appointmentId +
      "/" +
      "V";
    const payload = {
      url: shareurl,
      // patientId: patientdata.patientCode,
      // patientName: patientdata.patient,
      // userId: patientdata.doctorId,
      patientMobileNo: val,
      appointmentId: patientdata.appointmentId,
    };
    console.log(payload, "sedtrfgyuhjk");
    try {
      const response = await fetch(`${API_URL}prescriptions/share-link`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          tenantId: tenantId,
        },
        body: JSON.stringify(payload),
      });
      const result = await response.json();
      console.log(result, "result");
      if (result.status == 200) {
        // setorderid(result.data?.id);
        toast.success(result.message || "Link shared successfully");
        setModalVisible(false);
      } else {
        toast.error(
          result.message || "Something went wrong while sending Notification ",
        );
      }
    } catch (error) {
      toast.error("Something went wrong while submitting order");
    }
  };

  useEffect(() => {
    fetchQueueData();
    fetchCompletedAppointments();
    fetchFollowUpAppointments();
  }, [selectedDate]);

  const fetchQueueData = async () => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const formattedDate = format(selectedDate, "yyyy-MM-dd");

    try {
      const res = await fetch(
        `${API_URL}queue/waiting-area?date=${formattedDate}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            tenantId: tenantId,
          },
        },
      );
      const data = await res.json();

      if (Array.isArray(data)) {
        const nowData = [];
        const upcomingData = [];

        data.forEach((doctor) => {
          if (doctor?.nowServing?.appointmentId && doctor?.doctorId) {
            nowData.push({
              token: doctor.nowServing.token || "",
              patient: doctor.nowServing.name || "Unknown",
              patientMobileNumber: doctor.nowServing.patientMobileNumber || "",
              doctor: doctor.doctorName || "",
              doctorId: doctor.doctorId,
              appointmentId: doctor.nowServing.appointmentId,
              slot: doctor.nowServing.slot || "-",
              estimatedWaitTimeMins:
                doctor.nowServing.estimatedWaitTimeMins || "",
              position: "Now",
              status: "Active",
              consultationType: doctor.nowServing.consultationType,
              doctorId: doctor.doctorId || "",
              lastVisitDate: doctor.nowServing.lastVisitDate || "",
              noOfTotalVisit: doctor.nowServing.noOfTotalVisit || "",
            });
          }

          (doctor?.upcoming || []).forEach((item, idx) => {
            if (item?.appointmentId && doctor?.doctorId) {
              upcomingData.push({
                token: item.token || "",
                patient: item.name || "Unknown",
                patientMobileNumber: item.patientMobileNumber || "",
                doctor: doctor.doctorName || "",
                doctorId: doctor.doctorId,
                appointmentId: item.appointmentId,
                slot: item.slot || "-",
                estimatedWaitTimeMins: item.estimatedWaitTimeMins || "",
                position: `${idx + 1}`,
                status: item.status,
                patientCode: item.patientCode,
                consultationType: item.consultationType,
                doctorId: doctor.doctorId || "",
                lastVisitDate: item.lastVisitDate || "",
                noOfTotalVisit: item.noOfTotalVisit || "",
              });
            }
          });
        });

        setNowServingData(nowData);
        setQueueData(upcomingData);
        setUpcomingCount(upcomingData.length + nowData.length);
      } else {
        console.error("Unexpected data format:", data);
      }
    } catch (error) {
      console.error("Failed to fetch queue data:", error);
    }
  };
  const handleSkip = async (q) => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const formattedDate = format(selectedDate, "yyyy-MM-dd");

    // Set loading state for this specific appointment
    setSkippingAppointmentId(q.appointmentId);

    try {
      const res = await fetch(
        `${API_URL}queue/skip?doctorId=${q.doctorId}&date=${formattedDate}&appointmentId=${q.appointmentId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            tenantId: tenantId,
          },
        },
      );

      if (res.ok) {
        toast.success("Patient skipped successfully.");
        fetchQueueData();
      } else {
        const data = await res.json();
        const msg = data?.message || "Failed to skip the patient.";
        toast.error(msg);
      }
    } catch (err) {
      console.error("Skip error:", err);
      toast.error("Something went wrong while skipping.");
    } finally {
      // Clear loading state
      setSkippingAppointmentId(null);
    }
  };
  // const handleSkip = async (q) => {
  //   const token = localStorage.getItem("auth_token");
  //   const tenantId = localStorage.getItem("tenantId");
  //   const formattedDate = format(selectedDate, "yyyy-MM-dd");
  //   try {
  //     const res = await fetch(
  //       `${API_URL}queue/skip?doctorId=${q.doctorId}&date=${formattedDate}&appointmentId=${q.appointmentId}`,
  //       {
  //         method: "PUT",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //           tenantId: tenantId,
  //         },
  //       }
  //     );

  //     if (res.ok) {
  //       toast.success("Patient skipped successfully.");
  //       fetchQueueData();
  //     } else {
  //       const data = await res.json();
  //       const msg = data?.message || "Failed to skip the patient.";
  //       toast.error(msg);
  //     }
  //   } catch (err) {
  //     console.error("Skip error:", err);
  //     toast.error("Something went wrong while skipping.");
  //   }
  // };

  const handleCancel = async () => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const formattedDate = format(selectedDate, "yyyy-MM-dd");

    try {
      const res = await fetch(
        `${API_URL}queue/cancel?doctorId=${selecteddoctorId}&date=${formattedDate}&appointmentId=${selectedCancelId}&cancelledReason=${reason}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            tenantId: tenantId,
          },
        },
      );

      if (res.ok) {
        toast.success("Appointment cancelled successfully.");
        setIsCancelOpen(false);
        fetchQueueData();
      } else {
        const data = await res.json();
        const msg = data?.message || "Failed to cancel the appointment.";
        toast.error(msg);
      }
    } catch (err) {
      console.error("Cancel error:", err);
      toast.error("Something went wrong while cancelling.");
    }
  };

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchInput.trim().length >= 3) {
        handleSearch();
      } else {
        setSearchResults([]);
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchInput]);

  const handleSearch = async () => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const input = searchInput.trim();

    const isMobile = /^[0-9]+$/.test(input);
    const searchParam = isMobile
      ? `mobileNumber=${input}`
      : `firstName=${input}`;

    const url = `${API_URL}patient/search?${searchParam}`;

    try {
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          tenantId: tenantId,
        },
      });

      const data = await res.json();

      if (Array.isArray(data.data)) {
        setSearchResults(data.data);
      } else {
        setSearchResults([]);
        toast.error("No patient found.");
      }
    } catch (error) {
      console.error("Search error:", error);
      toast.error("Something went wrong while searching.");
    }
  };

  const handleclosecancel = () => {
    fetchQueueData();
    setIsCancelOpen(false);
  };

  const handleclosereschedule = () => {
    fetchQueueData();
    setIsRescheduleOpen(false);
  };

  const filteredQueueData = queueData.filter(
    (row) =>
      row.patient.toLowerCase().includes(tableSearch.toLowerCase()) ||
      row.patientMobileNumber.includes(tableSearch),
  );

  const openShareModal = (row) => {
    setPatientdata(row);
    setModalVisible(true);
  };

  // Mobile Card Component for Search Results
  const SearchResultMobileCard = ({ user, idx }) => (
    <div className="border-b border-gray-200 pb-4 last:border-b-0">
      <div className="flex justify-between items-start mb-2">
        <div className="flex-1">
          <h3 className="font-medium text-gray-900 capitalize text-sm">
            {user.firstName} {user.lastName}
          </h3>
          <p className="text-sm text-gray-600 mt-1">{user.mobileNumber}</p>
          <p className="text-sm text-gray-600">Age: {user.age}</p>
        </div>
      </div>
      <div className="flex gap-2 mt-3">
        <button
          className="flex-1 text-xs py-2 px-3 text-green-600 bg-green-50 rounded-md hover:bg-green-100 transition-colors"
          onClick={() =>
            navigate("/Patientregister", {
              state: { parentCode: user.patientCode },
            })
          }
        >
          +Add Member
        </button>
        <button
          className="flex-1 text-xs py-2 px-3 text-white bg-[#004276] rounded-md hover:bg-[#003661] transition-colors"
          onClick={() =>
            navigate("/BookServicescard", {
              state: { patientCode: user.patientCode, patient: user ,patientcbcode: user.curebayPatientId},
            })
          }
        >
          Book
        </button>
      </div>
    </div>
  );

  // Mobile Card Component for Queue Items
  const QueueMobileCard = ({ row, idx }) => (
    <div className="bg-white border border-gray-200 rounded-lg p-4 mb-4 shadow-sm">
      <div className="flex justify-between items-start mb-3">
        <div className="flex items-center gap-2">
          <span className="text-lg font-bold text-[#004276]">#{row.token}</span>
          <span
            className={`text-xs px-2 py-1 rounded-full font-medium ${
              row.status === "Queued"
                ? "bg-orange-100 text-orange-400"
                : row.status === "Active"
                  ? "bg-green-100 text-[#008d7b]"
                  : row.status === "Completed"
                    ? "bg-blue-100 text-[#005277]"
                    : "bg-red-100 text-red-700"
            }`}
          >
            {row.status}
          </span>
        </div>
        <div className="text-sm text-gray-500">
          {row.estimatedWaitTimeMins} mins
        </div>
      </div>

      <div className="space-y-2 mb-4">
        <div className="flex justify-between">
          <span className="text-sm text-gray-600">Patient:</span>
          <span className="text-sm font-medium text-gray-900">
            {row.patient}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-sm text-gray-600">Doctor:</span>
          <span className="text-sm font-medium text-gray-900">
            {row.doctor}
          </span>
        </div>
      </div>

      <div className="flex gap-2">
        <button
          onClick={() => {
            setSelectedToken(row.token);
            setSelectedappointmentid(row.appointmentId);
            setIsRescheduleOpen(true);
            setSelecteddoctorid(row.doctorId);
          }}
          className="flex-1 px-3 py-2 text-xs rounded-full bg-[#EDFFF9] text-[#00BD7F] hover:bg-[#d8f6ea] transition-colors"
        >
          Reschedule
        </button>
        {/* <button
          onClick={() => {
            handleSkip(row.doctorId, row.appointmentId);
          }}
          className="flex-1 px-3 py-2 text-xs rounded-full bg-yellow-50 text-yellow-700 hover:bg-yellow-100 transition-colors"
        >
          Skip
        </button> */}
        {row.consultationType === "V" && (
          <button
            onClick={() => {
              openShareModal(row);
            }}
            className="flex-1 px-3 py-2 text-xs rounded-full bg-[#FFEDED] text-[#004276] hover:bg-[#ffcccc] transition-colors"
          >
            Share Link
          </button>
        )}
      </div>
    </div>
  );

  // Tablet Card Component for Queue Items
  const QueueTabletCard = ({ row, idx }) => (
    <div className="bg-white border border-gray-200 rounded-lg p-4 mb-4 shadow-sm">
      <div className="flex justify-between items-start mb-3">
        <div className="flex items-center gap-3">
          <span className="text-xl font-bold text-[#004276]">#{row.token}</span>
          <span
            className={`text-sm px-3 py-1 rounded-full font-medium ${
              row.status === "Queued"
                ? "bg-orange-100 text-orange-400"
                : row.status === "Active"
                  ? "bg-green-100 text-[#008d7b]"
                  : row.status === "Completed"
                    ? "bg-blue-100 text-[#005277]"
                    : "bg-red-100 text-red-700"
            }`}
          >
            {row.status}
          </span>
        </div>
        <div className="text-sm text-gray-500 font-medium">
          {row.estimatedWaitTimeMins} mins
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 mb-4">
        <div>
          <span className="text-sm text-gray-600">Patient:</span>
          <p className="text-sm font-medium text-gray-900">{row.patient}</p>
        </div>
        <div>
          <span className="text-sm text-gray-600">Doctor:</span>
          <p className="text-sm font-medium text-gray-900">{row.doctor}</p>
        </div>
      </div>

      <div className="flex gap-3 justify-end">
        <button
          onClick={() => {
            setSelectedToken(row.token);
            setSelectedappointmentid(row.appointmentId);
            setIsRescheduleOpen(true);
            setSelecteddoctorid(row.doctorId);
          }}
          className="px-4 py-2 text-sm rounded-full bg-[#EDFFF9] text-[#00BD7F] hover:bg-[#d8f6ea] transition-colors"
        >
          Reschedule
        </button>
        {/* <button
          onClick={() => {
            handleSkip(row.doctorId, row.appointmentId);
          }}
          className="px-4 py-2 text-sm rounded-full bg-yellow-50 text-yellow-700 hover:bg-yellow-100 transition-colors"
        >
          Skip
        </button> */}
        {row.consultationType === "V" && (
          <button
            onClick={() => {
              openShareModal(row);
            }}
            className="px-4 py-2 text-sm rounded-full bg-blue-50 text-blue-700 hover:bg-blue-100 transition-colors border border-blue-200"
          >
            Share
          </button>
        )}
      </div>
    </div>
  );

  const handlePrint = async (row) => {
    setLoading(true);
    const formattedDate = format(selectedDate, "yyyy-MM-dd");
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    try {
      setDownloadingInvoiceId(row.appointmentId);
      const resp = await axios.get(
        `${API_URL}appointments/receipt/${row.appointmentId}?date=${formattedDate}`,
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
            tenantId: tenantId,
          },
        },
      );
      console.log(resp.data, "xdfghjk");
      const b64 = resp.data.data;
      const binStr = atob(b64);
      const len = binStr.length;
      const buf = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        buf[i] = binStr.charCodeAt(i);
      }
      const blob = new Blob([buf], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      setLoading(false);
      setDownloadingInvoiceId(false);
      setInvoiceURL(url);
      setInvoiceModalOpen(true);
    } catch (err) {
      toast.error("Failed to preview invoice.");
      console.error("Could not fetch invoice:", err);
    } finally {
      // setDownloadingInvoiceId(null);
    }
  };
  const checkAbhaVerified = (patient) => {
    return patient.abhaNumber && patient.preferredAbhaAddress;
  };
  const handleAbhaVerify = (patient) => {
    setSelectedPatientForAbha(patient);
    setIsAbhaVerifyOpen(true);
  };

  const handleAbhaClose = () => {
    setIsAbhaVerifyOpen(false);
    setIsAbhaCreateOpen(false);
    setSelectedPatientForAbha(null);
  };
  // const handleAbhaSuccess = () => {
  //   setIsAbhaVerifyOpen(false);
  //   setIsAbhaCreateOpen(false);
  //   setSelectedPatientForAbha(null);
  //   // Refresh search results to show updated ABHA status
  //   if (searchInput.trim().length >= 3) {
  //     handleSearch();
  //   }
  // };

  const handleAbhaSuccess = async (abhaData) => {
    try {
      // Parse ABHA data from verification/creation responses
      let abhaNumber = "";
      let preferredAbhaAddress = "";

      if (abhaData?.abhaProfile) {
        abhaNumber = abhaData.abhaProfile.abhaNumber || "";
        preferredAbhaAddress = abhaData.abhaProfile.preferredAbhaAddress || "";
      } else if (abhaData?.healthIdNumber) {
        abhaNumber = abhaData.healthIdNumber || "";
        preferredAbhaAddress = abhaData.preferredAbhaAddress || "";
      }

      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");

      if (selectedPatientForAbha?.patientCode) {
        const updatePayload = {
          firstName: selectedPatientForAbha.firstName,
          lastName: selectedPatientForAbha.lastName,
          gender: selectedPatientForAbha.gender,
          mobileNumber: selectedPatientForAbha.mobileNumber,
          abhaNumber: abhaNumber,
          preferredAbhaAddress: preferredAbhaAddress,
        };

        const res = await fetch(
          `${API_URL}patient/update/${selectedPatientForAbha.patientCode}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              tenantId: tenantId,
            },
            body: JSON.stringify(updatePayload),
          },
        );

        if (res.ok) {
          toast.success("Patient ABHA information updated successfully!");
        } else {
          try {
            const data = await res.json();
            toast.error(
              data?.message || "Failed to update patient ABHA information",
            );
          } catch (_) {
            toast.error("Failed to update patient ABHA information");
          }
        }
      }
    } catch (error) {
      console.error("Error updating patient ABHA information:", error);
      toast.error("Failed to update patient ABHA information");
    } finally {
      setIsAbhaVerifyOpen(false);
      setIsAbhaCreateOpen(false);
      setSelectedPatientForAbha(null);
      // Refresh search results to show updated ABHA status
      if (searchInput.trim().length >= 3) {
        handleSearch();
      }
    }
  };

  console.log(completedAppointments, "completedAppointments");

  const filteredNowServing = nowServingData.filter(
    (row) =>
      row.patient.toLowerCase().includes(tableSearch.toLowerCase()) ||
      row.patientMobileNumber.includes(tableSearch),
  );
  const allFilteredData = [...filteredNowServing, ...filteredQueueData];

  return (
    <OurLayouts>
      <div className="px-4 py-2 bg-gray-50 min-h-screen">
        {/* Search Banner */}
        <div className="bg-[#004276] text-white px-6 py-3 rounded-xl">
          <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-4">
            <h2 className="text-lg font-semibold flex items-center gap-2 mb-0">
              <img src={patientvectoricon} alt="Patient" className="w-5 h-5" />
              Searching for a Patient?
            </h2>
            <div className="flex flex-col sm:flex-row gap-3 items-stretch sm:items-center w-full lg:w-auto">
              <div className="relative flex-1 sm:min-w-[200px] lg:min-w-[250px]">
                <input
                  type="text"
                  placeholder="Search by"
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                  className="rounded-lg px-4 py-2 text-black w-full pr-10 text-sm"
                />
                <button className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500">
                  <img src={searchicon} alt="Search" className="w-4 h-4" />
                </button>
              </div>
              <button
                className="bg-[#00BD7F] hover:bg-[#019a75] px-4 sm:px-6 py-2 text-sm rounded-full font-medium whitespace-nowrap transition-colors flex items-center justify-center gap-2"
                onClick={() =>
                  navigate("/Patientregister", {
                    state: {
                      mobileNumber: (searchInput || "").replace(/[^0-9]/g, ""),
                    },
                  })
                }
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" />
                </svg>
                Register Patient
              </button>
            </div>
          </div>
        </div>

        {/* Search Results */}
        {searchResults.length > 0 && (
          <div className="mt-4 bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
            {viewMode === "mobile" ? (
              <div className="p-4 space-y-4">
                {searchResults.map((user, idx) => (
                  <SearchResultMobileCard key={idx} user={user} idx={idx} />
                ))}
              </div>
            ) : (
              // Tablet & Desktop View - Table
              <div className="overflow-x-auto">
                <table className="min-w-full text-sm">
                  <thead className="bg-gray-100 text-gray-700 font-semibold">
                    <tr>
                      <th className="p-2 text-left">Name</th>
                      <th className="p-2 text-left">Phone Number</th>
                      {!disabledFeatures.includes("ABDM") && (
                        <th className="p-2 text-left">ABHA Status</th>
                      )}
                      <th className="p-2 text-left">Age</th>
                      <th className="p-2 text-left">Add Family</th>
                      <th className="p-2 text-left">Book Services</th>
                    </tr>
                  </thead>
                  <tbody>
                    {searchResults.map((user, idx) => (
                      <tr key={idx} className="border-t">
                        <td className="p-2 capitalize">
                          {user.firstName} {user.lastName}
                        </td>
                        <td className="p-2">{user.mobileNumber}</td>
                        {!disabledFeatures.includes("ABDM") && (
                          <td className="p-2">
                            {checkAbhaVerified(user) ? (
                              <div className="relative overflow-hidden bg-gradient-to-br from-green-50 via-emerald-50 to-teal-50 border border-green-200/60 rounded-lg p-3 shadow-sm hover:shadow-md transition-all duration-300">
                                {/* Background Pattern */}
                                <div className="absolute top-0 right-0 w-8 h-8 bg-gradient-to-br from-green-200/20 to-transparent rounded-full -translate-y-4 translate-x-4"></div>

                                <div className="relative flex items-center gap-3">
                                  <div className="flex items-center justify-center w-8 h-8 bg-gradient-to-br from-green-400 to-emerald-500 rounded-full shadow-md">
                                    <svg
                                      className="w-4 h-4 text-white"
                                      fill="currentColor"
                                      viewBox="0 0 20 20"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                  <div className="flex-1 min-w-0">
                                    <div className="flex items-center gap-2 mb-1.5">
                                      <span className="text-xs font-bold text-green-800 tracking-wide">
                                        Verified
                                      </span>
                                    </div>
                                    <div className="bg-white/70 backdrop-blur-sm border border-green-200/50 rounded px-2 py-1.5">
                                      <div
                                        className="text-xs text-green-700 font-mono font-semibold tracking-wider truncate"
                                        title={user.abhaNumber}
                                      >
                                        {user.abhaNumber}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div className="relative overflow-hidden bg-gradient-to-br from-amber-50 via-orange-50 to-red-50 border border-orange-200/60 rounded-lg p-3 shadow-sm hover:shadow-md transition-all duration-300">
                                {/* Background Pattern */}
                                <div className="absolute top-0 right-0 w-8 h-8 bg-gradient-to-br from-orange-200/20 to-transparent rounded-full -translate-y-4 translate-x-4"></div>

                                <div className="relative flex items-center gap-3">
                                  <div className="flex items-center justify-center w-8 h-8 bg-gradient-to-br from-orange-400 to-red-500 rounded-full shadow-md">
                                    <svg
                                      className="w-4 h-4 text-white"
                                      fill="currentColor"
                                      viewBox="0 0 20 20"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                  <div className="flex-1 min-w-0">
                                    <div className="flex items-center gap-2 mb-2">
                                      <span className="text-xs font-bold text-orange-800 tracking-wide">
                                        Not Verified
                                      </span>
                                    </div>
                                    <button
                                      onClick={() => handleAbhaVerify(user)}
                                      className="group relative bg-gradient-to-r from-blue-500 via-blue-600 to-indigo-600 hover:from-blue-600 hover:via-blue-700 hover:to-indigo-700 text-white text-xs font-semibold px-3 py-1.5 rounded-lg transition-all duration-300 transform hover:scale-105 hover:shadow-md shadow-sm"
                                    >
                                      <div className="absolute inset-0 bg-gradient-to-r from-blue-400 to-indigo-500 rounded-lg opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
                                      <div className="relative flex items-center gap-1.5">
                                        <svg
                                          className="w-3 h-3"
                                          fill="currentColor"
                                          viewBox="0 0 20 20"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                            clipRule="evenodd"
                                          />
                                        </svg>
                                        <span>Verify ABHA</span>
                                      </div>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </td>
                        )}
                        <td className="p-2">{user.age}</td>
                        {!user.parentCode && (
                          <td
                            className="p-2 text-green-600 cursor-pointer hover:underline"
                            onClick={() =>
                              navigate("/Patientregister", {
                                state: { parentCode: user.patientCode },
                              })
                            }
                          >
                            +Add Member
                          </td>
                        )}
                        {user.parentCode && (
                          <td className="p-2 text-gray-400">Family Member</td>
                        )}
                        <td className="p-2">
                          <button
                            className="p-2 text-white cursor-pointer bg-[#004276] py-2 px-8 rounded-md hover:bg-[#003661] transition-colors"
                            // onClick={() =>
                            //   navigate("/VitalDetails", {
                            //     state: { patientCode: user.patientCode },
                            //   })
                            // }
                            onClick={() =>
                              navigate("/BookServicescard", {
                                state: {
                                  patientCode: user.patientCode,
                                  patient: user,
                                },
                              })
                            }
                          >
                            Book
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {/* Page Header */}
        <div className="mt-4">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-4">
            <div>
              <p className="text-xs text-gray-400 font-semibold uppercase tracking-widest mb-1">Daily Overview</p>
              <h3 className="text-xl font-bold leading-tight">
                <span className="text-[#1a2e4a]">Queue </span>
                <span className="text-[#00BD7F]">Management</span>
              </h3>
            </div>
            <DatePicker
              value={dayjs(selectedDate)}
              onChange={(val) => { if (val) setSelectedDate(val.toDate()); }}
              open={isCalendarOpen}
              onOpenChange={(open) => setIsCalendarOpen(open)}
              allowClear={false}
              inputReadOnly
              format="dddd, DD MMMM YYYY"
              suffixIcon={<img src={dateicon} alt="Calendar" style={{ width: 16, height: 16 }} />}
              style={{
                borderRadius: 12,
                boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                width: "auto",
                fontSize: 14,
                fontWeight: 500,
                color: "#374151",
              }}
              size="small"
            />
          </div>

          {/* Stats Cards */}
          <div className="mt-3 grid grid-cols-1 sm:grid-cols-3 gap-4">
            {/* Upcoming */}
            <div
              className={`bg-white rounded-2xl overflow-hidden cursor-pointer transition-all ${activeTab === "Upcoming" ? "border-2" : "border"}`}
              style={{ boxShadow: "0 0 6px 0 rgba(11,38,63,0.25)", borderColor: activeTab === "Upcoming" ? "#2558B8" : "#b8cef0" }}
              onClick={() => setActiveTab("Upcoming")}
            >
              <div className="h-[3px] rounded-tl-2xl rounded-tr-2xl" style={{ background: "linear-gradient(90deg, #2558B8, #4B7ED4)" }}></div>
              <div className="px-3 py-2 flex items-center gap-3">
                <div className="w-10 h-10 bg-blue-50 rounded-lg flex items-center justify-center flex-shrink-0 border border-blue-100">
                  <img src={Upcomingicon} className="w-5 h-5" />
                </div>
                <div>
                  <p className="text-xs text-gray-500 font-medium">Upcoming</p>
                  <p className="text-2xl font-bold text-gray-800 leading-tight">{upcomingCount}</p>
                  <p className="text-[11px] text-gray-400">appointments today</p>
                </div>
              </div>
            </div>

            {/* Completed */}
            <div
              className={`bg-white rounded-2xl overflow-hidden cursor-pointer transition-all ${activeTab === "Completed" ? "border-2" : "border"}`}
              style={{ boxShadow: "0 0 6px 0 rgba(11,38,63,0.25)", borderColor: activeTab === "Completed" ? "#0D6B6E" : "#a8d8d5" }}
              onClick={() => { setActiveTab("Completed"); fetchCompletedAppointments(); }}
            >
              <div className="h-[3px] rounded-tl-2xl rounded-tr-2xl" style={{ background: "linear-gradient(90deg, #0D6B6E, #0A9E8A)" }}></div>
              <div className="px-3 py-2 flex items-center gap-3">
                <div className="w-10 h-10 bg-green-50 rounded-lg flex items-center justify-center flex-shrink-0 border border-green-100">
                  <img src={Completeicon} className="w-5 h-5" />
                </div>
                <div>
                  <p className="text-xs text-gray-500 font-medium">Completed</p>
                  <p className="text-2xl font-bold text-gray-800 leading-tight">{completedCount}</p>
                  <p className="text-[11px] text-gray-400">consultations done</p>
                </div>
              </div>
            </div>

            {/* Follow ups */}
            <div
              className={`bg-white rounded-2xl overflow-hidden cursor-pointer transition-all ${activeTab === "Follow ups" ? "border-2" : "border"}`}
              style={{ boxShadow: "0 0 6px 0 rgba(11,38,63,0.25)", borderColor: activeTab === "Follow ups" ? "#7C3AED" : "#DDD6FE" }}
              onClick={() => { setActiveTab("Follow ups"); fetchFollowUpAppointments(); }}
            >
              <div className="h-[3px] rounded-tl-2xl rounded-tr-2xl" style={{ background: "linear-gradient(90deg, #7C3AED, #A78BFA)" }}></div>
              <div className="px-3 py-2 flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 border" style={{ background: "#F5F3FF", borderColor: "#EDE9FE" }}>
                  <img src={Followupicon} className="w-5 h-5" />
                </div>
                <div>
                  <p className="text-xs text-gray-500 font-medium">Follow ups</p>
                  <p className="text-2xl font-bold leading-tight" style={{ color: "#7C3AED" }}>{followUpCount}</p>
                  <p className="text-[11px] text-gray-400">pending follow-ups</p>
                </div>
              </div>
            </div>
          </div>

          {/* Tab Content Sections */}
          <div className="mt-3">
            {/* Follow ups Tab Content */}
            {activeTab === "Follow ups" && (
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 px-3 py-2">
                <h3 className="text-lg font-semibold text-[#004276] mb-2">
                  Follow ups
                </h3>

                {loadingFollowUp ? (
                  <div className="text-center py-8">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#004276] mx-auto mb-2"></div>
                    <div className="text-sm text-gray-500">
                      Loading follow-up appointments...
                    </div>
                  </div>
                ) : followUpAppointments.length > 0 ? (
                  <div className="space-y-4">
                    {/* <div className="text-sm text-gray-600 mb-4">
                    Total: {followUpCount} follow-up appointments
                  </div> */}

                    {/* Desktop Table View */}
                    <div className="overflow-x-auto">
                      <table className="w-full text-sm text-left text-gray-700">
                        <thead className="bg-[#F5F8FA] text-[#004276] font-medium text-[14px]">
                          <tr className="border-b border-[#D9E9F5]">
                            <th className="py-3 text-center">
                              Patient Details
                            </th>
                            <th className="py-3  text-center">Doctor Name</th>
                            <th className="py-3  text-center">
                              Follow-up Date
                            </th>
                            <th className="py-3  text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody className="text-[14px]">
                          {followUpAppointments.map((appointment, idx) => (
                            <tr
                              key={idx}
                              className="border-b border-[#E2EDF4] hover:bg-[#F9FAFB] transition-colors"
                            >
                              <td className="py-3 px-6">
                                <div className="flex items-center justify-between">
                                  <div className="flex flex-col">
                                    <div className="font-bold text-[#004276] text-left">
                                      {appointment.patientName}
                                    </div>
                                    <div className="text-sm text-gray-500 text-left">
                                      {appointment.patientMobileNo}
                                    </div>
                                    <div className="text-sm text-gray-400 text-left">
                                      Last Visit:{" "}
                                      {appointment.visitDate &&
                                      !isNaN(
                                        new Date(
                                          appointment.visitDate,
                                        ).getTime(),
                                      )
                                        ? format(
                                            new Date(appointment.visitDate),
                                            "MMM dd, yyyy",
                                          )
                                        : "N/A"}
                                    </div>
                                  </div>
                                  <div className="text-lg font-medium text-gray-700 text-center">
                                    {appointment.noOfTotalVisit}
                                  </div>
                                </div>
                              </td>
                              <td className="py-3 px-6 text-center">
                                Dr. {appointment.doctorName}
                              </td>
                              <td className="py-3 px-6 text-center">
                                {appointment.followUpVisitDate &&
                                !isNaN(
                                  new Date(
                                    appointment.followUpVisitDate,
                                  ).getTime(),
                                )
                                  ? format(
                                      new Date(appointment.followUpVisitDate),
                                      "MMM dd, yyyy",
                                    )
                                  : "N/A"}
                              </td>
                              <td className="py-3 px-6 text-center">
                                {/* <span className={`text-sm px-2.5 py-0.5 rounded-md font-semibold w-fit ${
                                appointment.status === "PENDING" ? "text-orange-600 bg-orange-100" :
                                appointment.status === "COMPLETED" ? "text-green-600 bg-green-100" :
                                "text-gray-600 bg-gray-100"
                              }`}>
                                {appointment.status || "PENDING"}
                              </span> */}
                                <button
                                  className="px-4 py-2 text-[#004276] border border-[#004276] rounded-xl hover:bg-[#004276] hover:text-white transition-colors"
                                  onClick={() => {
                                    console.log(appointment, "serdtfyguhi");
                                    // Navigate to SlotBooking with patient data and follow-up date
                                    navigate("/SlotBooking", {
                                      state: {
                                        patientCode: appointment.patientId,
                                        patient: {
                                          firstName:
                                            appointment.patientName?.split(
                                              " ",
                                            )[0] || "",
                                          lastName:
                                            appointment.patientName
                                              ?.split(" ")
                                              .slice(1)
                                              .join(" ") || "",
                                          mobileNumber:
                                            appointment.patientMobileNo || "",
                                        },
                                        followUpDate: appointment.followUpDate,
                                        doctorCode: appointment.userId, // Add doctor code
                                        isFollowUp: true,
                                      },
                                    });
                                  }}
                                >
                                  Schedule Follow Up
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <div className="text-center py-8">
                    <div className="text-gray-500 mb-2">
                      No follow-up appointments found
                    </div>
                    {/* <div className="text-sm text-gray-400">(Tap to refresh)</div> */}
                  </div>
                )}
              </div>
            )}

            {/* Completed Tab Content */}
            {activeTab === "Completed" && (
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 px-3 py-2">
                <h3 className="text-lg font-semibold text-[#004276] mb-2">
                  Completed Appointments
                </h3>

                {loadingCompleted ? (
                  <div className="text-center py-8">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#004276] mx-auto mb-2"></div>
                    <div className="text-sm text-gray-500">
                      Loading completed appointments...
                    </div>
                  </div>
                ) : completedAppointments.length > 0 ? (
                  <div className="space-y-4">
                    {/* <div className="text-sm text-gray-600 mb-4">
                    Total: {completedCount} completed appointments for {format(selectedDate, "MMM dd, yyyy")}
                  </div> */}

                    {/* Desktop Table View */}
                    <div className="overflow-x-auto">
                      <table className="w-full text-sm text-left text-gray-700">
                        <thead className="bg-[#F5F8FA] text-[#004276] font-medium text-[14px]">
                          <tr className="border-b border-[#D9E9F5]">
                            <th className="py-3  text-center">Token Number</th>
                            <th className="py-3 text-center">
                              Patient Details
                            </th>
                            <th className="py-3 text-center">Doctor Name</th>
                            <th className="py-3  text-center">
                              Consultation Type
                            </th>
                            <th className="py-3 text-center">Slot Time</th>
                            {/* <th className="py-3 px-6 text-center">Completed Time</th> */}
                          </tr>
                        </thead>
                        <tbody className="text-[14px]">
                          {completedAppointments.map((appointment, idx) => (
                            <tr
                              key={idx}
                              className="border-b border-[#E2EDF4] hover:bg-[#F9FAFB] transition-colors"
                            >
                              <td className="py-3 text-center">
                                <span className="font-medium text-[#004276]">
                                  {appointment.tokenNumber || appointment.token}
                                </span>
                              </td>
                              <td className="py-3 px-6">
                                <div className="flex items-center justify-between">
                                  <div className="flex flex-col">
                                    <div className="font-bold text-blue-600 text-left">
                                      {appointment.patientName ||
                                        appointment.patient}
                                    </div>
                                    <div className="text-sm text-gray-500 text-left">
                                      {appointment.patientMobileNo}
                                    </div>
                                    {/* <div className="text-sm text-gray-400 text-left">
                                    Last Visit: {appointment.lastVisitDate}
                                  </div> */}
                                  </div>
                                  <div className="text-lg font-medium text-gray-700 text-center">
                                    {appointment.noOfTotalVisit}
                                  </div>
                                </div>
                              </td>
                              <td className="py-3 px-6 text-center">
                                Dr.{" "}
                                {appointment.doctorName || appointment.doctor}
                              </td>
                              <td className="py-3 px-6 text-center">
                                {appointment.consultationType === "V"
                                  ? "Video"
                                  : appointment.consultationType === "I"
                                    ? "In-person"
                                    : ""}
                              </td>
                              <td className="py-3 px-6 text-center">
                                {appointment.fromTime}- {appointment.toTime}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <div className="text-center py-8">
                    <div className="text-gray-500 mb-2">
                      No completed appointments found
                    </div>
                    {/* <div className="text-sm text-gray-400">for {format(selectedDate, "MMM dd, yyyy")}</div> */}
                  </div>
                )}
              </div>
            )}

            {/* Upcoming Tab Content */}
            {activeTab === "Upcoming" && (
              <div>
                {/* Section header + search */}
                <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 mb-2">
                  <div>
                    <h3 className="text-lg font-semibold">
                      <span className="text-[#004276]">Upcoming </span>
                      <span className="text-[#00BD7F]">Appointments</span>
                    </h3>
                    <p className="text-sm text-gray-400">Manage active and queued patient sessions</p>
                  </div>
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="Search today's queue..."
                      value={tableSearch}
                      onChange={(e) => setTableSearch(e.target.value)}
                      className="px-4 py-2 border border-gray-200 rounded-xl w-64 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200 bg-white"
                    />
                    <button type="button" className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                      </svg>
                    </button>
                  </div>
                </div>

                {/* Now Serving Cards */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-5">
                  {nowServingData.map((q, idx) => {
                    const isActive = q.status === "Active" || q.status === "ACTIVE";
                    const headerBg = isActive
                      ? "linear-gradient(135deg, #F0FAF8, #E4F7F4)"
                      : "linear-gradient(135deg, #FFFBF5, #FFF4E4)";
                    const dotColor = isActive ? "#01BE80" : "#E8A020";
                    const badgeBorder = isActive ? "#01BE80" : "#E8A020";
                    const badgeText = isActive ? "#01807B" : "#B86A00";
                    return (
                      <div
                        key={`${q.token}-${idx}`}
                        className="bg-white rounded-xl overflow-hidden"
                        style={{ border: "1px solid #0A9E8A", boxShadow: "0 2px 8px rgba(0,0,0,0.07)" }}
                      >
                        {/* Card Header */}
                        <div
                          className="px-3 py-2 flex items-center justify-between"
                          style={{ background: headerBg, borderBottom: "0.8px solid rgba(0,0,0,0.05)" }}
                        >
                          <div className="flex items-center gap-1.5">
                            <span className="w-2 h-2 rounded-full inline-block" style={{ backgroundColor: dotColor }}></span>
                            <span className="text-xs font-bold text-[#1a2e4a]">Token: {q.token}</span>
                          </div>
                          <span
                            className="text-[11px] px-2 py-0.5 rounded-full font-semibold"
                            style={{ border: `1px solid ${badgeBorder}`, color: badgeText }}
                          >
                            {q.status}
                          </span>
                        </div>

                        {/* Card Body */}
                        <div className="px-3 pt-2 pb-1">
                          <div className="grid grid-cols-2 gap-x-3 gap-y-2 mb-2">
                            <div>
                              <p className="text-[9px] text-gray-400 uppercase font-semibold tracking-widest mb-0.5">Patient Name</p>
                              <p className="text-xs font-bold text-[#1a2e4a]">{q.patient}</p>
                            </div>
                            <div>
                              <p className="text-[9px] text-gray-400 uppercase font-semibold tracking-widest mb-0.5">Doctor</p>
                              <p className="text-xs font-bold text-[#004276]">{q.doctor}</p>
                            </div>
                            <div>
                              <p className="text-[9px] text-gray-400 uppercase font-semibold tracking-widest mb-0.5">Mobile</p>
                              <p className="text-xs font-bold text-[#1a2e4a]">{q.patientMobileNumber}</p>
                            </div>
                            <div>
                              <p className="text-[9px] text-gray-400 uppercase font-semibold tracking-widest mb-0.5">Type</p>
                              {q.consultationType === "V" ? (
                                <span className="inline-flex items-center gap-1 text-[11px] px-1.5 py-0.5 bg-blue-50 text-blue-600 rounded-full border border-blue-200 font-medium">
                                  <img src={Videoicon} className="w-2.5 h-2.5" alt="" /> Video
                                </span>
                              ) : (
                                <span className="inline-flex items-center gap-1 text-[11px] px-1.5 py-0.5 bg-green-50 text-green-600 rounded-full border border-green-200 font-medium">
                                  <img src={Inpersionicon} className="w-2.5 h-2.5" alt="" /> In-Person
                                </span>
                              )}
                            </div>
                          </div>

                          <div
                            className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium text-[#1a2e4a] mb-2"
                            style={{ background: "rgba(0,0,0,0.04)" }}
                          >
                            <svg className="w-3 h-3 text-[#004276]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            {q.slot}
                          </div>
                        </div>

                        {/* Action Button */}
                        <div className="px-3 pb-3">
                          <button
                            onClick={() => handleSkip(q)}
                            disabled={skippingAppointmentId === q.appointmentId}
                            className="w-full py-2 text-sm text-white rounded-lg transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-1.5"
                            style={{ background: "linear-gradient(135deg, #01807B, #004276)" }}
                          >
                            {skippingAppointmentId === q.appointmentId ? (
                              <>
                                <span className="animate-spin inline-block w-3 h-3 border-b-2 border-white rounded-full"></span>
                                Skipping...
                              </>
                            ) : (
                              <>
                                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 5l7 7-7 7M5 5l7 7-7 7" />
                                </svg>
                                Skip
                              </>
                            )}
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>

                {/* Today's Full Queue Table */}
                <div>
                  <h3 className="text-lg font-semibold text-gray-800">Today's Full Queue</h3>
                  <p className="text-sm text-gray-400 mb-3">All {filteredQueueData.length} patients scheduled for today</p>

                  <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden">
                    <div className="overflow-x-auto">
                      <table className="w-full text-sm text-left text-gray-700">
                        <thead>
                          <tr className="bg-[#dceee9]">
                            <th className="py-3 px-4 text-[#004276] font-semibold">Patient</th>
                            <th className="py-3 px-4 text-[#004276] font-semibold">Token</th>
                            <th className="py-3 px-4 text-[#004276] font-semibold">Doctor</th>
                            <th className="py-3 px-4 text-[#004276] font-semibold">Type</th>
                            <th className="py-3 px-4 text-[#004276] font-semibold">Status</th>
                            <th className="py-3 px-4 text-[#004276] font-semibold">Slot Time</th>
                            <th className="py-3 px-4 text-[#004276] font-semibold">Duration</th>
                            <th className="py-3 px-4 text-[#004276] font-semibold">Print Slip</th>
                            <th className="py-3 px-4 text-[#004276] font-semibold">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredQueueData.map((row, idx) => (
                            <tr key={idx} className="border-b border-gray-100 hover:bg-gray-50 transition-colors">
                              <td className="py-3 px-4">
                                <p className="font-semibold text-gray-800">{row.patient}</p>
                                <p className="text-xs text-gray-400">{row.patientMobileNumber}</p>
                              </td>
                              <td className="py-3 px-4">
                                <span className="inline-flex items-center bg-[#dceee9] text-[#004276] px-2.5 py-1 rounded-full text-xs font-bold">
                                  {row.token}
                                </span>
                              </td>
                              <td className="py-3 px-4 text-gray-700">Dr. {row.doctor}</td>
                              <td className="py-3 px-4">
                                {row.consultationType === "V" ? (
                                  <span className="inline-flex items-center gap-1.5 text-xs px-2.5 py-1 bg-blue-50 text-blue-600 rounded-full border border-blue-200 font-medium">
                                    <img src={Videoicon} className="w-3 h-3" alt="" /> Video
                                  </span>
                                ) : row.consultationType === "I" ? (
                                  <span className="inline-flex items-center gap-1.5 text-xs px-2.5 py-1 bg-green-50 text-green-600 rounded-full border border-green-200 font-medium">
                                    <img src={Inpersionicon} className="w-3 h-3" alt="" /> In-Person
                                  </span>
                                ) : null}
                              </td>
                              <td className="py-3 px-4">
                                <span className={`inline-flex items-center gap-1.5 text-xs px-2.5 py-1 rounded-full font-semibold ${
                                  row.status === "Active"
                                    ? "bg-green-100 text-green-700"
                                    : row.status === "QUEUED"
                                    ? "bg-orange-100 text-orange-600"
                                    : "bg-gray-100 text-gray-600"
                                }`}>
                                  <span className={`w-1.5 h-1.5 rounded-full ${
                                    row.status === "Active" ? "bg-green-500" :
                                    row.status === "QUEUED" ? "bg-orange-500" : "bg-gray-400"
                                  }`}></span>
                                  {row.status}
                                </span>
                              </td>
                              <td className="py-3 px-4 text-gray-700">{row.slot}</td>
                              <td className="py-3 px-4 text-gray-700">
                                {row.estimatedWaitTimeMins ? `${row.estimatedWaitTimeMins} mins` : "-"}
                              </td>
                              <td className="py-3 px-4">
                                <button
                                  onClick={() => handlePrint(row)}
                                  disabled={downloadingInvoiceId === row.appointmentId}
                                  className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold disabled:opacity-60 hover:opacity-80 transition-opacity"
                                  style={{ border: "1.5px solid #0A9E8A", color: "#0A9E8A", background: "white" }}
                                >
                                  <svg className="w-3.5 h-3.5" fill="none" stroke="#0A9E8A" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
                                  </svg>
                                  {downloadingInvoiceId === row.appointmentId ? "Printing..." : "Print"}
                                </button>
                              </td>
                              <td className="py-3 px-4">
                                <div className="flex justify-center items-center">
                                  <div className="relative dropdown-container">
                                    <button
                                      onClick={() => setOpenDropdownId(openDropdownId === row.appointmentId ? null : row.appointmentId)}
                                      className="w-8 h-8 flex items-center justify-center rounded-lg hover:opacity-80 transition-opacity"
                                      style={{ border: "1.5px solid #0A9E8A" }}
                                    >
                                      <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none">
                                        <circle cx="12" cy="12" r="10" fill="url(#infoGrad)" />
                                        <text x="12" y="16.5" textAnchor="middle" fill="white" fontSize="13" fontWeight="bold" fontFamily="serif">i</text>
                                        <defs>
                                          <linearGradient id="infoGrad" x1="0" y1="0" x2="1" y2="1">
                                            <stop offset="0%" stopColor="#0A9E8A" />
                                            <stop offset="100%" stopColor="#004276" />
                                          </linearGradient>
                                        </defs>
                                      </svg>
                                    </button>
                                    {openDropdownId === row.appointmentId && (
                                      <div className="absolute right-0 mt-2 w-48 bg-white rounded-xl shadow-lg border border-gray-200 z-50">
                                        <div className="py-1">
                                          <button
                                            onClick={() => {
                                              setSelectedToken(row.token);
                                              setSelectedappointmentid(row.appointmentId);
                                              setSelectedSlot("");
                                              setIsRescheduleOpen(true);
                                              setSelecteddoctorid(row.doctorId);
                                              setOpenDropdownId(null);
                                            }}
                                            className="flex items-center w-full px-4 py-2 text-sm text-emerald-700 hover:bg-emerald-50 transition-colors"
                                          >
                                            <svg className="w-4 h-4 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                            </svg>
                                            Reschedule
                                          </button>
                                          {row.consultationType === "V" && (
                                            <button
                                              onClick={() => { openShareModal(row); setOpenDropdownId(null); }}
                                              className="flex items-center w-full px-4 py-2 text-sm text-blue-700 hover:bg-blue-50 transition-colors"
                                            >
                                              <svg className="w-4 h-4 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.367 2.684 3 3 0 00-5.367-2.684z" />
                                              </svg>
                                              Share
                                            </button>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))}
                          {filteredQueueData.length === 0 && (
                            <tr>
                              <td colSpan={9} className="py-10 text-center text-gray-400">No patients in queue</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    {/* Table Footer */}
                    <div className="flex items-center justify-between px-4 py-3 border-t border-gray-100">
                      <p className="text-sm text-gray-500">
                        Showing all {filteredQueueData.length} scheduled Patients Details
                      </p>
                      <div className="flex items-center gap-1">
                        <button className="w-7 h-7 flex items-center justify-center rounded-full text-gray-400 hover:bg-gray-100 text-sm">&lt;</button>
                        <button className="w-7 h-7 flex items-center justify-center rounded-full bg-[#004276] text-white text-xs font-bold">1</button>
                        <button className="w-7 h-7 flex items-center justify-center rounded-full text-gray-400 hover:bg-gray-100 text-xs">2</button>
                        <button className="w-7 h-7 flex items-center justify-center rounded-full text-gray-400 hover:bg-gray-100 text-xs">3</button>
                        <span className="text-gray-400 text-xs px-1">...</span>
                        <button className="w-7 h-7 flex items-center justify-center rounded-full text-gray-400 hover:bg-gray-100 text-sm">&gt;</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Others Tab Content */}
            {/* {activeTab === "Others" && (
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
              <h3 className="text-lg font-semibold text-[#004276] mb-4">Other Appointments</h3>
              <div className="text-center py-8">
                <div className="text-gray-500 mb-2">No other appointments</div>
                <div className="text-sm text-gray-400">(Tap to refresh)</div>
              </div>
            </div>
          )} */}
          </div>
        </div>
      </div>

      {/* Sidebars and Modals */}
      {isRescheduleOpen && (
        <RescheduleSidebar
          isOpen={isRescheduleOpen}
          onClose={handleclosereschedule}
          selectedToken={selectedToken}
          appontmentdate={selectedDate}
          selectedSlot={selectedSlot}
          setSelectedSlot={setSelectedSlot}
          selectedappointmentid={selectedappointmentid}
          doctorid={selecteddoctorid}
        />
      )}

      {isCancelOpen && (
        <CancelSidebar
          isOpen={isCancelOpen}
          onClose={handleclosecancel}
          reason={reason}
          setReason={setReason}
          onCancelAppointment={handleCancel}
        />
      )}

      <ShareLinkModal
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        onSend={handleSend}
        setRecipient={setRecipient}
        recipient={recipient}
      />

      {invoiceModalOpen && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-2 md:p-4">
          <div className="bg-white w-full max-w-3xl h-full max-h-[95vh] rounded-lg shadow-lg overflow-hidden relative">
            <div className="flex justify-between items-center p-3 md:p-4 border-b">
              <h2 className="text-lg md:text-xl font-semibold text-[#003A71]">
                Slip
              </h2>
              <button
                className="text-gray-500 hover:text-red-500 text-2xl font-bold"
                onClick={() => {
                  setInvoiceModalOpen(false);
                  URL.revokeObjectURL(invoiceURL);
                }}
              >
                &times;
              </button>
            </div>
            <div className="h-[calc(100%-60px)] overflow-auto p-1 md:p-2">
              {invoiceURL && (
                <iframe
                  src={invoiceURL}
                  title="Invoice PDF"
                  className="w-full h-full border-0"
                />
              )}
            </div>
          </div>
        </div>
      )}

      {/* ABHA Verification Modal */}
      {isAbhaVerifyOpen && selectedPatientForAbha && (
        <VerifyAbhaModal
          visible={isAbhaVerifyOpen}
          onClose={handleAbhaClose}
          mobileNumber={selectedPatientForAbha.mobileNumber}
          onSuccess={handleAbhaSuccess}
          onCreateAbha={() => {
            setIsAbhaVerifyOpen(false);
            setIsAbhaCreateOpen(true);
          }}
        />
      )}

      {/* ABHA Creation Modal */}
      {isAbhaCreateOpen && selectedPatientForAbha && (
        <CreateAbhaModal
          isOpen={isAbhaCreateOpen}
          onClose={handleAbhaClose}
          onSuccess={handleAbhaSuccess}
          initialMobileNumber={selectedPatientForAbha.mobileNumber}
          showAsModal={true}
        />
      )}
    </OurLayouts>
  );
}
